<template>
  <div>
    <i class="fal fa-clipboard-user fa-fw mr-1"></i>
    {{ $t('EVENTS.LABEL.WAITLIST_REGISTRATIONS') }}:
    {{ numberOfWaitlistRegistrations }}
  </div>
</template>

<script>
export default {
  name: 'EventWaitlistRegistrationsComponent',
  props: {
    numberOfWaitlistRegistrations: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped></style>
